import ChangedDepositProfileFields from 'app/components/auth/ChangedDepositProfileFields';
import React, {Component} from 'react';
import I18n from 'app/i18n';
import {isDesktop} from 'app/utils';
import CashoutHistory from './cashout_history';
import CashoutSystemTabs from './cashout_system_tabs';
import {CashoutForm} from './cashout_form';
import {inject, observer} from 'mobx-react';
import SmartPageLoader from 'app/components/reusable/smart_loaders/SmartPageLoader';
import withRouter from 'app/utils/navigate/customWithRouter';
import {CashoutsStoreProps, CashoutsFormInterface} from 'app/store/CashoutsStore';
import {DepositsStoreProps} from 'app/store/DepositsStore';
import {UserStore} from 'app/store/UserStore';
import {getLinkPath} from 'app/utils/link_helper';
import {navigateGoTo} from 'app/utils/navigate/navigateGoTo';

interface CashoutPageProps extends CashoutsStoreProps, DepositsStoreProps {
    userStore?: UserStore
    params?: {
        system_slug: string
    }
}

class CashoutPage extends Component<CashoutPageProps> {
    componentDidMount() {
        const {cashoutsStore, params} = this.props;

        cashoutsStore.fetchCashoutsData()
            .then(data => {
                if (data?.success) {
                    this.selectFirstCashoutSystem(data, params?.system_slug);
                }
            })
            .finally(() => cashoutsStore.updateLoading(false));
    }

    componentDidUpdate(oldProps: CashoutPageProps) {
        const oldSlug = oldProps.params?.system_slug;
        const newSlug = this.props.params?.system_slug;
        const {cashoutsStore} = this.props;

        if (oldSlug !== newSlug) {
            cashoutsStore.selectSystemBySlug(newSlug);

            if (newSlug) {
                cashoutsStore.selectFirstWallet();
            } else if (isDesktop()) {
                this.selectFirstCashoutSystem(cashoutsStore.data);
            }
        }
    }

    selectFirstCashoutSystem = (data: CashoutsFormInterface, params_system_slug?: string): void => {
        if (params_system_slug) {
            this.props.cashoutsStore.selectSystemBySlug(params_system_slug);
        } else if (isDesktop()) {
            const systems = data.systems_order.filter((systemId: number) => this.activeFilter(data, systemId));

            if (systems.length > 0) {
                navigateGoTo(getLinkPath(`/withdraws/${data.systems[systems[0]].slug}`), {}, true);
            }
        }
    };

    activeFilter = (data: CashoutsFormInterface, systemId: number) => {
        const system = data.systems[systemId];
        const hasWallet = Boolean(data.wallets[systemId]);
        return system && !system.hidden && hasWallet;
    };

    renderLoading = (): React.ReactNode => <div className="cashout">
        <div className="cashout-title">
            <h2 className="title-h1">{I18n.t('user.withdraw')}</h2>
        </div>
        <SmartPageLoader/>
    </div>;

    renderResponseError = (message: string): React.ReactNode => <div>
        <div className="cashout">
            <div className="cashout-title">
                <h1 className="title-h1">{I18n.t('user.withdraw')}</h1>
            </div>
            <div className="cashout-error-message">{message}</div>
        </div>
    </div>;

    renderRegistrationForm = (): React.ReactNode => {
        const {depositsStore, userStore: {user}} = this.props;

        return <div className="cashout cashout-fill-in-fields">
            <div className="cashout-title">
                <h1 className="title-h1">{I18n.t('user.fill_in_fields_to_make_a_cashout')}:</h1>
            </div>
            <div className="form-content deposit-form form form-egb used-chosen">
                <div className="deposit-form__inputs">
                    <ChangedDepositProfileFields depositsStore={depositsStore} {...user}/>
                </div>
            </div>
        </div>;
    };

    render() {
        const {cashoutsStore, userStore} = this.props;
        const {loading, data} = cashoutsStore;

        if (loading) {
            return this.renderLoading();
        }

        if (!data.success) {
            return this.renderResponseError(data.message);
        }

        if (!userStore.fullRegistered()) {
            return this.renderRegistrationForm();
        }

        const {systems, systems_order, wallets, selectedSystem, china_dictionaries, china_banks} = data;
        const listsFullWidthClass = isDesktop() && !selectedSystem ? 'payment-systems__cashout-lists--full-width' : '';

        return <div className="cashout">
            {selectedSystem && !isDesktop()
                ? <CashoutForm
                    china_dictionaries={china_dictionaries}
                    china_banks={china_banks}
                />
                : <>
                    <div className="cashout-title">
                        {isDesktop()
                            ? <h2 className="title-h1">{I18n.t('user.withdraw')}</h2>
                            : <h1 className="title-h1">{I18n.t('user.withdraw')}</h1>}
                    </div>
                    <div className="payment-systems payment-systems__cashout">
                        <div className="payment-systems__container">
                            <div className={`payment-systems__cashout-lists ${listsFullWidthClass}`}>
                                <CashoutSystemTabs
                                    systems={systems}
                                    systems_order={systems_order}
                                    wallets={wallets}
                                    active
                                    selected_system_slug={selectedSystem?.slug}
                                />
                                <CashoutSystemTabs
                                    systems={systems}
                                    systems_order={systems_order}
                                    wallets={wallets}
                                />
                            </div>
                            {isDesktop() && selectedSystem && <div className="payment-systems__cashout-details">
                                <div className="payment-systems__selectedSystem">
                                    <CashoutForm
                                        china_dictionaries={china_dictionaries}
                                        china_banks={china_banks}
                                    />
                                </div>
                            </div>}
                        </div>
                    </div>
                </>}
            <CashoutHistory/>
        </div>;
    }
}

export default withRouter(inject('cashoutsStore', 'depositsStore', 'userStore')(observer(CashoutPage)));
